import { UserOutputDTO } from "@kalyzee/kast-web-sdk/http";
import { User } from "@kalyzee/kast-web-sdk/websocket";

export const getNormalUser = (user: UserOutputDTO | User) => {
  let lastname: string;
  let firstname: string;
  let avatar: string;
  let username: string;
  let email: string;
  if ("identity" in user) {
    lastname = user.identity?.lastname || "";
    firstname = user.identity?.firstname || "";
    avatar = user.identity?.avatar || "";
    username = user.identity?.username || "";
    email = user.identity?.email || "";
  } else {
    lastname = user.lastname || "";
    firstname = user.firstname || "";
    avatar = user.avatar || "";
    username = user.username || "";
    email = user.email || "";
  }
  const displayName = `${firstname || ""} ${lastname || ""}`.trim() || username || email;
  return { displayName, avatar };
};
